import React, { Component } from 'react'
import { connect } from 'react-redux'

class NotFoundView extends Component {

  componentDidMount() {
    window.analytics.page('Not found')
  }

  render() {
    return (
      <div className="col-md-12">
        <p className="well lead">404 - Page not found :-(</p>
      </div>
    );
  }
}

export default connect()(NotFoundView)



/** WEBPACK FOOTER **
 ** ./src/containers/NotFoundView.js
 **/